<template>
  <div style="height: 100%; display: flex; flex-direction: column; justify-content: space-around;">
    <div class="loading-spinner-outer" v-if="saving">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Saving, please wait
        </div>
      </div>
    </div>
    <div class="loading-spinner-outer" v-if="loading">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Loading, please wait
        </div>
      </div>
    </div>
    <div class="modal-window-inner" @click.stop style="max-width: 1000px; max-height: 100%; overflow: auto;">
      <div class="modal-header">
        <h1 class="modal-title">Add Lead Recipients</h1>
      </div>
      <div class="modal-content">
        <p class="align-center">
          Please add 1–3 lead recipients to continue.
        </p>
        <p class="align-center">
          This ensures leads are sent to the appropriate people.
        </p>
        <table class="table">
          <tbody>
          <tr v-for="user in users" :key="user.id">
            <td>
              <input type="checkbox" :id="`lead_user_checkbox_${user.id}`" :value="user.id" v-model="selected_user_ids" :disabled="!selected_user_ids.includes(user.id) && selected_user_ids.length >= 3">
            </td>
            <td>
              <label :for="`lead_user_checkbox_${user.id}`">
                {{ user.name }}
              </label>
            </td>
            <td>
              <label :for="`lead_user_checkbox_${user.id}`">
                {{ user.email }}
              </label>
            </td>
          </tr>
          </tbody>
        </table>
        <div>
          <div class="align-right mb-6">
            <a class="btn-primary" @click="submitLeadRecipients()">
              Submit
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'logged_in_user',
  ],
  mounted() {
    this.loadUsers();
  },
  data() {
    return {
      loading: true,
      saving: false,
      users: [],
      selected_user_ids: [],
    }
  },
  methods: {
    loadUsers() {
      this.loading = true;
      axios.get('/company/lead-recipients/load-available-users').then((response) => {
        this.users = response.data;
        this.loading = false;
      });
    },
    submitLeadRecipients() {
      this.saving = true;
      axios.post('/company/lead-recipients/update', {
        selected_user_ids: this.selected_user_ids,
      }).then((response) => {
        this.saving = false;
        this.$emit('close');
        Swal.fire({
          title: 'Submitted',
          icon: 'success',
          html: `<div class="mb-3">Thank you for updating your companies lead recipients.</div>`,
        });
      });
    },
  },
  watch: {},
};
</script>
